import React from 'react';
import LinkButton from './LinkButton';
import styles from './LinkButton.module.scss';
import MaterialIcon from './MaterialIcon';

type Props = {
    iconName: string;
    link: string;
    linkText: string;
};
const LinkWithIcon = ({ iconName, link, linkText }: Props): JSX.Element => {
    return (
        <div className={styles.linkWrapper}>
            <MaterialIcon name={iconName} />
            <LinkButton link={link} label={linkText} />
        </div>
    );
};

export default LinkWithIcon;
